/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/aria-role */
import { useDrag } from 'react-dnd';

const CanDrag = ({ children, dragItem, index, onEndDrag, canDrag }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'Box',
    item: () => ({
      dragItem,
    }),
    end: onEndDrag,
    canDrag: canDrag ?? false,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  });
  return (
    <div div ref={drag} role='Box' data-testid={`box-${dragItem.text}`}>
      {children}
    </div>
  );
};

export default CanDrag;
